module.exports = "/work-site/img/banner.a492dea4.png";